import { clearKbGroupId } from './kbGroupId';
import { clearCachedAccessibleGroups } from './accessibleGroupsCache';
import { clearNotificationsBackground } from './notificationsBackground';

/**
 * Clears tab-scoped session state that must not survive logout / account switch.
 * localStorage auth clearing is handled separately by callers.
 */
export function clearSessionScopedState() {
  clearKbGroupId();
  clearCachedAccessibleGroups();
  clearNotificationsBackground();
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem('tenantSlug');
  } catch {
    // ignore quota / private mode
  }
}
